<template>
  <!-- 社教活动管理 -->
  <div class="page-activity-manage">
    <!-- 列表头部 -->
    <div class="com-list-header" style="padding-right: 20px;padding-bottom: 10px">
      <el-form @keyup.enter.native="getTableList" :model="form" class="com-search-box" ref="form" label-width="80px">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="图书名称 :" prop="name">
              <el-input v-model="form.name" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="图书总号 :" prop="bookNo">
              <el-input v-model="form.bookNo" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item class="el-form-state1" label="出版社 :" prop="publisher">
              <el-input v-model="form.publisher" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item class="el-form-state" label="作者 :" prop="author">
              <el-input v-model="form.author" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div class="btn-wrapper">
        <el-button type="primary" @click="getTableList">查询</el-button>
        <el-button @click="restList('form')">重置</el-button>
      </div>

    </div>

    <!-- 列表内容 -->
    <div class="com-list-content">
      <div class="button">
        <el-row type="flex">
          <el-button style="margin-right: 20px" @click="addBook" class="el-primary-border">
            <svg-icon icon-class="add" />&nbsp;新增图书
          </el-button>

          <el-upload style="margin-right: 20px" ref="bookImport" action="/singleMuseum/book/bsBookInfo/export"
            :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload"
            :data="uploadData">
            <el-button class="el-primary-border">
              <svg-icon icon-class="add" />&nbsp;导入
            </el-button>
          </el-upload>

          <cmpMyExport @clearSelectsCall="clearSelectsCall" :chooseIds="chooseRowIds"
            chooseApi="/book/bsBookInfo/exportBook?type=1&ids="></cmpMyExport>

          <!-- <el-button @click="exportList" :class="{'el-primary-border':chooseRowIds}" :disabled="!chooseRowIds">
            <svg-icon icon-class="add" />&nbsp;导出
          </el-button> -->
        </el-row>
      </div>
      <div class="table mt-20">
        <el-table ref="multipleTable" v-loading="listLoading" stripe :data="tableData"
          @selection-change="handleSelectionChange">
          <!-- <el-table-column label="序号" width="50">
            <template slot-scope="scope">{{ scope.$index+1 }}</template>
          </el-table-column> -->
          <el-table-column type="selection" width="55">
          </el-table-column>
          <el-table-column prop="name" label="图书名称" min-width="10%" show-overflow-tooltip></el-table-column>
          <el-table-column prop="bookNo" label="图书总号" min-width="7%"></el-table-column>
          <el-table-column prop="typeNo" label="分类号" min-width="7%"></el-table-column>
          <el-table-column prop="laiyuan" label="来源" min-width="7%">
            <!-- <template slot-scope="scope">{{ scope.row.laiyuan | filterSourceType(that) }}</template> -->
          </el-table-column>
          <el-table-column prop="author" label="作者" min-width="7%"></el-table-column>
          <el-table-column prop="publisher" label="出版社" min-width="12%"></el-table-column>
          <el-table-column prop="total" label="数量" min-width="7%"></el-table-column>
          <el-table-column prop="remain" label="剩余数" min-width="7%"></el-table-column>

          <!-- <el-table-column label="状态" min-width="7%">
            <template slot-scope="scope">{{ scope.row.status | filterStatus }}</template>
          </el-table-column> -->

          <el-table-column fixed="right" label="操作" min-width="10%">
            <template slot-scope="scope">
              <a class="m-btn mr-10" @click="handleView(scope.row.id)">查看</a>
              <a class="m-btn mr-10" @click="handleEdit(scope.row)">编辑</a>
              <a class="m-btn mr-10 m-danger" @click="handleDelete(scope.row.id)">删除</a>

              <!-- <a class="m-btn mr-10" @click="borrowBook(scope.row.id)">借阅</a>
              <a class="m-btn mr-10" v-if="scope.row.attachment" @click="download(scope.row)">下载</a> -->
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background
            layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>

    <el-dialog :title="operation=='add' ? '新增图书': operation =='edit' ? '编辑图书': '查看图书'" :visible.sync="dialogVisible"
      width="40%" :before-close="handleClose">
      <el-form class="g-form-grid" ref="addForm" :model="addForm" label-width="90px" :rules="rules">
        <el-form-item label="图书名称 :" prop="name">
          <el-input v-model="addForm.name" :disabled="operation == 'detail'" placeholder="请输入"></el-input>
        </el-form-item>

        <el-form-item label="分类号 :" prop="typeNo">
          <el-input v-model="addForm.typeNo" :disabled="operation == 'detail'" placeholder="请输入"></el-input>
        </el-form-item>

        <el-form-item label="总号 :" prop="bookNo">
          <el-input v-model="addForm.bookNo" :disabled="operation == 'detail'" placeholder="请输入"></el-input>
        </el-form-item>

        <el-form-item label="出版社 :" prop="publisher">
          <el-input v-model="addForm.publisher" :disabled="operation == 'detail'" placeholder="请输入"></el-input>
        </el-form-item>

        <el-form-item label="出版时间 :" prop="publishTime">
          <el-input v-model="addForm.publishTime" :disabled="operation == 'detail'" placeholder="请输入"></el-input>

          <!-- <el-date-picker v-model="addForm.publishTime" :disabled="operation == 'detail'" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" type="date" placeholder="请选择"></el-date-picker> -->
        </el-form-item>

        <el-form-item label="作者 :" prop="author">
          <el-input v-model="addForm.author" :disabled="operation == 'detail'" placeholder="请输入"></el-input>
        </el-form-item>

        <el-form-item label="册数 :" prop="total">
          <el-input type="number" :disabled="operation == 'detail'" v-model="addForm.total"
            placeholder="请输入"></el-input>
        </el-form-item>

        <el-form-item label="装帧 :" prop="zhaungzhen">
          <el-input v-model="addForm.zhaungzhen" :disabled="operation == 'detail'" placeholder="请输入"></el-input>
        </el-form-item>

        <el-form-item label="价格 :" prop="price">
          <el-input type="number" :disabled="operation == 'detail'" v-model="addForm.price"
            placeholder="请输入"></el-input>
        </el-form-item>

        <el-form-item label="购入时间 :" prop="gourusj">
          <el-date-picker v-model="addForm.gourusj" :disabled="operation == 'detail'" format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="请选择"></el-date-picker>
        </el-form-item>

        <el-form-item label="架位 :" prop="jiawei">
          <el-input v-model="addForm.jiawei" :disabled="operation == 'detail'" placeholder="请输入"></el-input>
        </el-form-item>

        <el-form-item label="来源 :" prop="laiyuan">
          <el-select allow-create filterable v-model="addForm.laiyuan" :disabled="operation == 'detail'"
            placeholder="请输入">
            <el-option v-for="item in bookSourceList" :key="item.dictCode" :label="item.dictName"
              :value="item.dictCode"></el-option>
          </el-select>
        </el-form-item>

        <!-- <el-form-item label="备注 :" prop="remark">
          <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入内容" v-model="addForm.remark"></el-input>
        </el-form-item>

        <el-form-item label="附件 :" prop="attachment">
          <cmpUploadProgress ref="cmpUploadProgress" :callFun="uploadCallback" :accept="`.rar, .zip, .doc, .docx, .pdf, .jpg`"></cmpUploadProgress>
        </el-form-item> -->

        <!-- :fileList="form.attachmentList" -->

      </el-form>
      <span slot="footer" class="dialog-footer" v-if="operation != 'detail'">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" :loading="loadingSave" @click="handleSubmit">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="借阅图书" :visible.sync="dialogVisible1" width="30%">
      <el-form class="g-form-grid" ref="borrowForm" :model="borrowForm" label-width="90px" :rules="borrowRules">
        <el-form-item label="借阅数量 :" prop="num">
          <el-input v-model.number="borrowForm.num" placeholder="请输入"></el-input>
        </el-form-item>

        <el-form-item label="借阅天数 :" prop="day">
          <el-input v-model="borrowForm.day" placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose1">取 消</el-button>
        <el-button type="primary" @click="handleBorrow()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import cmpUploadProgress from '@cmp/my-upload/upload-progress' // 上传组件
import axios from 'axios'
import cmpMyExport from '@cmp/my-export'
import { removeEmptyField } from '@/utils/util'

export default {
  components: {
    cmpUploadProgress,
    cmpMyExport
  },
  data() {
    var checkTypeNo = (rule, value, callback) => {
      if (this.addForm.typeNo === '') {
        callback(new Error('分类号不能为空'));
      } else {
        if (this.addForm.typeNo !== '') {
          let str = this.addForm.typeNo.slice(0, 1)
          if (!/^[A-Z]+$/.test(str)) {
            callback(new Error('分类号必须以大写字母开头'));
          }
        }
      }
    };
    return {
      that: this,
      chooseRowIds: '',
      form: {
        name: '',
        bookNo: '',
        publisher: '',
        author: ''
      },
      addForm: {
        name: '',
        typeNo: '',
        bookNo: '',
        laiyuan: '',
        publisher: '',
        publishTime: '',
        author: '',
        total: '',
        zhaungzhen: '',
        price: '',
        gourusj: '',
        jiawei: '',
        type: 1,

      },
      loadingSave: false,
      borrowForm: {
        num: '',
        day: '',
      },
      rules: {
        name: [
          { required: true, message: '图书名称不能为空', trigger: 'blur' },
        ],

        bookNo: [
          { required: true, message: '图书总号不能为空', trigger: 'blur' },
        ],

        typeNo: [
          { required: true, message: '图书分类号不能为空', trigger: 'blur' },
          { validator: checkTypeNo, trigger: 'blur' }
        ],

        publisher: [
          { required: true, message: '出版社不能为空', trigger: 'blur' },
        ],

        author: [
          { required: true, message: '作者不能为空', trigger: 'blur' },
        ],

        total: [
          { required: true, message: '图书数量不能为空', trigger: 'blur' },
        ],
      },

      borrowRules: {
        num: [
          { required: true, message: '请输入借阅数量', trigger: 'blur' },
        ],
      },
      operation: '',
      borrowId: '',
      listLoading: true,
      tableData: [],
      bookSourceList: [],
      listQuery: {
        currentPage: 1,
        size: 10
      },
      bookStatus: [{
        dictCode: 1,
        dictName: '可借阅'
      }, {
        dictCode: 2,
        dictName: '可阅览'
      }],
      total: 0,
      uploadData: {
        // file: '',
        type: 1
      },
      dialogVisible: false,
      dialogVisible1: false
    }
  },

  filters: {
    filterSourceType(type, that) {
      let obj = that.bookSourceList.filter(item => {
        return item.dictCode == type
      })

      if (obj && obj.length > 0) {
        return obj[0].dictName
      }

      return null
    },

    filterStatus(status) {
      if (status == 1) {
        return '可借阅'
      } else if (status == 2) {
        return '可阅览'
      } else {
        return null
      }
    }
  },

  methods: {
    initData() {
      this.listLoading = true
      this.tableData = []
      this.$api.book.getBookPageList({
        ...this.form,
        type: 1,
        ...this.listQuery
      }).then(res => {
        if (res.success) {
          this.tableData = res.result.records
          this.total = res.result.total
        }
        this.listLoading = false
      }).catch(err => {
        this.listLoading = false
      })

    },

    exportList() {
      if (!this.chooseRowIds) {
        this.$message.warning('请选择要导出的图书')
        return
      }
      location.href =
        '/singleMuseum//book/bsBookApproval/export?ids=' + this.chooseRowIds
      // this.$api.volunteer.exportAdultList({ids:this.chooseRowIds}).then(res=>{
      //   console.log(res)
      // })
    },

    handleSelectionChange(list) {
      let arr = []
      list.forEach(item => {
        arr.push(item.id)
      })
      this.chooseRowIds = arr.join(',')
    },


    handleView(id) {
      this.operation = "detail"
      this.dialogVisible = true
      this.$api.book.getBookDetail({
        id: id,
      }).then(res => {
        if (res.success) {
          this.addForm = res.result
        }
      })
    },

    handleEdit(obj) {
      this.operation = "edit"
      this.dialogVisible = true
      this.addForm = JSON.parse(JSON.stringify(obj))
    },

    // 清空选中状态
    clearSelectsCall() {
      this.$refs.multipleTable.clearSelection()
    },

    // 删除
    handleDelete(id) {
      this.$common.confirm(
        {
          title: `是否删除该图书？`,
          className: 'cus-confirm-375'
        }, () => {
          this.$api.book.deleteBookInfo({ id: id }).then(res => {
            if (res.success) {
              this.$message.success('删除成功')
              this.initData()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      )
    },

    // 获取下拉状态多选择值
    getDropdownValue() {
      this.$http.get('/collectDict/getSelectDataByKey', {
        key: 'book_source'
      }).then(res => {
        if (res.success) {
          this.bookSourceList = res.result
        } else {
          this.$message.error(res.message)
        }
      })
    },

    // 详情
    borrowBook(id) {
      this.borrowId = id
      this.dialogVisible1 = true
    },

    getTableList() {
      this.listQuery.currentPage = 1
      this.initData()
    },


    //下载图书
    download(obj) {
      axios({
        method: 'get',
        url: '/singleMuseum/book/bsBookInfo/download',
        responseType: 'blob', //二进制流
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        params: {
          attachmentId: obj.attachment
        }
      }).then(res => {
        if (res) {
          let fileName = obj.name, fileType = "txt";
          const blob = new Blob([res.data]);
          if (res.headers) {
            let contentDisposition = res.headers['content-disposition'];
            if (contentDisposition) {
              fileName = window.decodeURI(res.headers['content-disposition'].split('=')[1], "UTF-8");

            }
            // if (fileName) {
            //   fileName = fileName.split('.')[0]
            //   fileType = fileName.split('.')[1]
            // }
          }
          const linkNode = document.createElement('a');
          linkNode.setAttribute('download', fileName);
          linkNode.style.display = 'none';
          linkNode.href = URL.createObjectURL(blob); //生成一个Blob URL
          document.body.appendChild(linkNode);
          linkNode.click();  //模拟在按钮上的一次鼠标单击

          URL.revokeObjectURL(linkNode.href); // 释放URL 对象
          document.body.removeChild(linkNode);
        }
      })
    },

    // 文件上传回调
    uploadCallback(fileStr) {
      this.addForm.attachment = fileStr
    },

    restList(formName) {
      this.$refs[formName].resetFields();
      this.listQuery.currentPage = 1
      this.initData()
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.initData()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.initData()
    },

    //新增
    addBook() {
      this.operation = 'add'
      this.dialogVisible = true
    },

    handleClose() {
      this.$refs['addForm'].resetFields()
      // this.$refs['cmpUploadProgress'].viewFileList = []
      this.dialogVisible = false
    },

    handleClose1() {
      this.$refs['borrowForm'].resetFields()
      this.dialogVisible1 = false
    },

    // 上传之前设置参数
    beforeAvatarUpload(file) {
      // let formData = new FormData()
      // formData.append('file', file.raw)
      // this.uploadData.file = formData
    },

    // 导入成功回调
    handleAvatarSuccess(res) {
      if (res.success) {
        this.$message.success('导入成功')
        this.initData()
      } else {
        this.$message.error(res.message)
      }
    },

    //借阅图书
    handleBorrow() {
      this.$refs['borrowForm'].validate(vaild => {
        if (vaild) {
          this.$api.book.borrowBook({
            num: this.borrowForm.num,
            type: 1,
            day: this.borrowForm.day ? parseInt(this.borrowForm.day) : 0,
            id: this.borrowId
          }).then(res => {
            if (res.success) {
              this.$message.success('借阅成功')
              this.handleClose1()
              this.initData()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      })
    },

    handleSubmit() {
      this.addForm = removeEmptyField(this.addForm)
      this.$refs['addForm'].validate(vaild => {
        if (vaild) {
          this.loadingSave = true
          let url = ''
          if (this.operation == 'edit') {
            url = 'updateBookInfo'
          } else {
            url = 'addBookInfo'
          }
          this.$api.book[url]({
            ...this.addForm,
          }).then(res => {
            this.loadingSave = false
            if (res.success) {
              if (this.operation == 'edit') {
                this.$message.success('图书修改成功')
              } else {
                this.$message.success('新增成功')

              }
              this.handleClose()
              this.initData()
            }
          }).catch(err => {
            this.loadingSave = false
          })
        }
      })
    }

  },

  mounted() {
    this.getDropdownValue()
    this.initData()
  }
}
</script>

<style lang="scss" scoped>
.btn-wrapper {
  display: flex;
  justify-content: right;
  margin: 10px 0;
}

/deep/ .el-dialog {
  .el-date-editor {
    width: 100%;
  }
}

.el-form-state {
  /deep/ .el-form-item__label {
    width: 58px !important;
  }

  /deep/ .el-form-item__content {
    margin-left: 60px !important;
  }
}

.el-form-state1 {
  /deep/ .el-form-item__label {
    width: 70px !important;
  }

  /deep/ .el-form-item__content {
    margin-left: 70px !important;
  }
}
</style>